<div class="search">
  <svg class="search__icon">
    <use xlink:href="images/sprites5.svg#icon-search"></use>
  </svg>
  <input
    type="text"
    class="search__input"
    placeholder="Search"
    class="search__input"
    (keydown.enter)="onEnter()"
    [(ngModel)]="searchQuery"
  />
</div>
